export const BORDER_COLOR = {
	actionDisabled: 'border-action-disabled',
	actionPrimaryDisabled: 'border-action-primary-disabled',
	actionSecondaryDefault: 'border-action-secondary-default',
	actionSecondaryDisabled: 'border-action-secondary-disabled',
	actionTertiaryDisabled: 'border-action-tertiary-disabled',
	actionPrimaryDefault: 'border-action-primary-default',
	iconActionDefault: 'border-icon-action-default',
	feedbackErrorDefault: 'border-feedback-error-default',
	feedbackErrorDefaultImportant: '!border-feedback-error-default',
	feedbackInfoDefault: 'border-feedback-info-default',
	feedbackSuccessDefault: 'border-feedback-success-default',
	feedbackSuccessDefaultImportant: '!border-feedback-success-default',
	feedbackWarningDefault: 'border-feedback-warning-default',
	feedbackWarningDefaultImportant: '!border-feedback-warning-default',
	// neutralDefault: 'border-neutral-default', // untested
	neutralSubtle: 'border-neutral-subtle',
	// neutralInverted: 'border-neutral-inverted', // untested
	textNeutralDisabled: 'border-text-neutral-disabled',
} as const;

export type BorderColor = keyof typeof BORDER_COLOR;

/* eslint-disable @stylistic/no-multi-spaces */
export const BORDER_RADIUS = {
	// xxs: 'rounded-xxs', // Doesn't exist in frisk, nor tailwind.
	xs: 'rounded-xs',     // --design-border-radius-xs 0.15rem (2,4px)
	sm: 'rounded-sm',     // --design-border-radius-sm 0.25rem (4px)
	md: 'rounded-md',     // --design-border-radius-md 0.5rem (8px)
	lg: 'rounded-lg',     // --design-border-radius-lg 2rem (32px)
	xl: 'rounded-xl',     // tailwind 0.75rem (12px)
	'2xl': 'rounded-2xl', // tailwind 1rem (16px)
	'3xl': 'rounded-3xl', // tailwind 1.5rem (24px)
} as const;
/* eslint-enable @stylistic/no-multi-spaces */

export type BorderRadius = keyof typeof BORDER_RADIUS;


export const BORDER_STYLE = {
	solid: 'border-solid',
	dashed: 'border-dashed',
	dotted: 'border-dotted',
	double: 'border-double',
	hidden: 'border-hidden',
	none: 'border-none',
} as const;

export type BorderStyle = keyof typeof BORDER_STYLE;

export const BORDER_WIDTH = {
	1: 'border',
	sm: 'border-sm',
	md: 'border-md',
} as const;

export type BorderWidth = keyof typeof BORDER_WIDTH;
